import { render, staticRenderFns } from "./ScheduleTemplateItem.vue?vue&type=template&id=052651b2&scoped=true"
import script from "./ScheduleTemplateItem.vue?vue&type=script&lang=js"
export * from "./ScheduleTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./ScheduleTemplateItem.vue?vue&type=style&index=0&id=052651b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052651b2",
  null
  
)

export default component.exports